import { IEvent, IHost } from "@Interfaces";
import { IModalTypes, IPaymentInfoForSingleOffering, IUseModal } from "@Utils";
import { Dispatch } from "redux";
import { IAboutPlan } from "@Modules/eventPage/components/AboutPlan/IAboutPlan";
import { getAboutCreatorProps } from "../components/AboutCreator/data";
import { getAboutEventProps } from "../components/AboutEvent/data";
import { getAddressInfoProps } from "../components/AddressInfo/data";
import { getContentHeaderProps } from "../components/ContentHeader/data";
import { getCreatorFAQProps } from "../components/CreatorFAQ/data";
import { getDiscountProps } from "../components/Discount/data";
import { getEventMediaProps } from "../components/EventMedia/data";
import { getOfferPromotionProps } from "../components/OfferPromotion/data";

import {
    IAboutCreator,
    IAboutEvent,
    IAddressInfo,
    IContentHeader,
    ICreatorFAQ,
    IDiscount,
    IEventMedia,
    IWrapperComponentType,
} from "../components/Interfaces";
import { IOfferPromotion } from "../components/OfferPromotion/IOfferPromotion";
import { IEventModule } from "./IEventModule";
import { getAboutPlanProps } from "../components/AboutPlan/data";
import { IPlanDropdown } from "../components/PlanDropdown/IPlanDropdown";
import { InstalmentsDetailsContextProps } from "../components/PaymentPlan/utils/InstalmentsDetailsContext";

export const getEventModuleChildProps = ({
    dispatch,
    event,
    eventData,
    host,
    eventId,
    planId,
    isMobile,
    dynamicLink,
    showGuestInfoModal,
    handleOpenModal,
    mainScrolledComponentRef,
    hideDiscount,
    callApplyDiscountApi,
    disablePayment,
    showLoyaltyDiscountsPopup,
    setShowLoyaltyDiscountsPopup,
    showLoyaltyDiscountSection,
    computedPaymentValues,
    wrapperComponentType,
    getDropdownSelectorsProps,
    isDiscountAppliedOnInstallments,
    refetchInstallments,
}: {
    dispatch: Dispatch<any>;
    event: IEvent.IStore;
    eventData: IEvent.IEventData;
    host: IHost.IStore;
    eventId: string;
    planId?: string;
    isMobile: boolean;
    dynamicLink?: string;
    showGuestInfoModal: () => void;
    handleOpenModal: (
        modalTypeArg: IModalTypes,
        openModalArgs?: IUseModal.IOpenModalProps
    ) => void;
    mainScrolledComponentRef: React.RefObject<HTMLDivElement>;
    hideDiscount: boolean;
    callApplyDiscountApi: (
        newDiscountCode: string,
        newDiscountCodeType: IEvent.IAppliedDiscountCodeType,
        newCustomerEmail?: string
    ) => void;
    disablePayment: boolean;
    showLoyaltyDiscountsPopup: boolean;
    setShowLoyaltyDiscountsPopup: (param: boolean) => void;
    showLoyaltyDiscountSection: boolean;
    computedPaymentValues: IPaymentInfoForSingleOffering.IReturn;
    wrapperComponentType: IWrapperComponentType;
    getDropdownSelectorsProps: (
        depthIndex: number
    ) => IPlanDropdown.DropdownSelectorsPropsType;
    isDiscountAppliedOnInstallments?: boolean;
    refetchInstallments: InstalmentsDetailsContextProps["refetchInstallments"];
}): IEventModule.ChildProps => {
    const hostData: IHost.IHostData = host.dataHost.profile_data!;

    const aboutCreatorProps: IAboutCreator.IProps = getAboutCreatorProps({
        hostData,
        eventData,
        dynamicLink,
        showGuestInfoModal,
        handleOpenModal,
    });

    const aboutEventProps: IAboutEvent.IProps = getAboutEventProps({
        planId,
        eventData,
        host,
    });

    const aboutPlanProps: IAboutPlan.IProps = getAboutPlanProps({
        planId,
        eventData,
        host,
    });

    const addressInfoProps: IAddressInfo.IProps = getAddressInfoProps({
        hostData,
        eventData,
    });

    const contentHeaderProps: IContentHeader.IBaseProps = getContentHeaderProps(
        {
            host,
            eventData,
            planId,
            isMobile,
        }
    );

    const creatorFAQProps: ICreatorFAQ.IProps = getCreatorFAQProps({
        eventData,
    });

    const discountProps: IDiscount.IProps = getDiscountProps({
        eventId,
        event,
        eventData,
        dispatch,
        hideDiscount,
        callApplyDiscountApi,
        mainScrolledComponentRef,
        disablePayment,
        showLoyaltyDiscountsPopup,
        setShowLoyaltyDiscountsPopup,
        showLoyaltyDiscountSection,
        isMobile,
        computedPaymentValues,
        isDiscountAppliedOnInstallments,
        refetchInstallments,
    });

    const eventMediaProps: IEventMedia.IProps = getEventMediaProps({
        host,
        eventData,
        wrapperComponentType,
        planId,
        getDropdownSelectorsProps,
    });

    const offerPromotionProps: IOfferPromotion.IProps = getOfferPromotionProps({
        eventData,
        isMobile,
        callApplyDiscountApi,
        discountData: event.discount,
        disablePayment,
    });

    const eventModuleChildProps: IEventModule.ChildProps = {
        aboutCreatorProps,
        aboutEventProps,
        aboutPlanProps,
        addressInfoProps,
        contentHeaderProps,
        creatorFAQProps,
        discountProps,
        eventMediaProps,
        offerPromotionProps,
    };

    return eventModuleChildProps;
};
